
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19800.865 -13890.419 14.992 10.451"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-19799.714-13885.244l4.051 4.126 8.64-8.151","fill":"none","stroke":"444444","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"2.3","opacity":".54"}})])
          )
        }
      }
    